<template>
  <div class="sign-status-notification">
    <Form :model="formValidate" label-position="right" :label-width="250">
      <FormItem label="是否开启学生考勤状态通知设置：">
        <RadioGroup
          v-model="formValidate.settingSwitch"
          @on-change="onRadioChange"
        >
          <Radio :label="0">否</Radio>
          <Radio :label="1">是</Radio>
        </RadioGroup>
        <p class="color-gray">
          开启后，指定的考勤状态被设置后，将通知对应的指定用户。
        </p>
      </FormItem>
      <div v-show="formValidate.settingSwitch == 1">
        <FormItem label="选择对应的考勤状态：">
          <Checkbox
            v-model="formValidate.signStatus"
            disabled
          >状态：缺勤</Checkbox>
          <p class="color-gray">
            表示指定的考勤状态下，将通过指定的通知方式，通知对应的用户。
          </p>
        </FormItem>
        <FormItem label="通知用户：">
          <CheckboxGroup v-model="formValidate.notifyUserType">
            <Checkbox :label="1">通知学生的班主任</Checkbox>
            <Checkbox :label="2">通知学生的家长（多家长时全量推送）</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="推送方式：">
          <Checkbox
            v-model="formValidate.pushMethod"
            disabled
          >微信公众号（需先关注）</Checkbox>
        </FormItem>
      </div>
    </Form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formValidate: {
        settingSwitch: 0,
        notifyUserType: [],
        signStatus: true,
        pushMethod: true
      }
    };
  },
  created() {

  },
  methods: {
    onRadioChange(val) {
      if (val == 1) {
        this.formValidate.notifyUserType = [];
      }
    },
    setFormValidate(info) {
      this.formValidate.settingSwitch = info.settingSwitch;
      this.formValidate.notifyUserType = info.notifyUserType;
    },
    getParameter() {
      const { settingSwitch, notifyUserType, signStatus, pushMethod } = this.formValidate;
      return {
        settingSwitch,
        signStatus: [5],
        notifyUserType: settingSwitch == 1 ? notifyUserType : [],
        pushMethod: [1]
      };
    }
  }
};
</script>

<style lang="scss" scoped >
.sign-status-notification {
  padding-bottom: 10px;
}
</style>
